import Axios from "axios";
import { BASE_URL, FALLBACK_URL } from "../Utils/const";
import authService from "./AuthService";

const api = Axios.create({
  timeout: 5000,
});

export class Http {
  static _getHeader() {
    return {
      "Authorization": `Bearer ${authService.getToken()}`,
    };
  }

  static async get(endpoint, params) {
    const options = {
      headers: this._getHeader(),
    };
    if (params && Object.keys(params).length) {
      options.params = params;
    }
    try {
      return await api.get(BASE_URL + endpoint, options);
    } catch (err) {
      console.warn("BASE_URL fail → fallback");
      return api.get(FALLBACK_URL + endpoint, options);
    }
  }

  static async post(endpoint, payload) {
    try {
      return await api.post(BASE_URL + endpoint, payload, {
        headers: this._getHeader(),
      });
    } catch {
      return api.post(FALLBACK_URL + endpoint, payload, {
        headers: this._getHeader(),
      });
    }
  }
}